// ERP 백엔드와 통신 — fetch 기반, 인증 없음 (위젯은 비회원도 접근).

export interface Attachment {
  url: string;
  name?: string;
  mime?: string;
}

export interface Message {
  id: string;
  direction: 'inbound' | 'outbound';
  text: string;
  attachments: Attachment[];
  sent_by: string | null;
  sent_at: string | null;
}

export interface PollResult {
  inquiry_id: string | null;
  channel?: string;
  customer_name?: string | null;
  customer_phone?: string | null;
  messages: Message[];
  server_time: string;
}

export interface PostMessageResult {
  inquiry_id: string;
  message_id: string;
  channel: string;
}

export interface WidgetConfig {
  channel?: string;
  title?: string;
  greeting?: string;
  eta?: string;
  online_hours?: string;
  poll_interval_sec?: number;
}

export class ChatApi {
  constructor(public erpUrl: string, public site: string) {}

  private url(path: string): string {
    return this.erpUrl.replace(/\/$/, '') + '/api/chat/direct' + path;
  }

  async getConfig(): Promise<WidgetConfig> {
    const r = await fetch(this.url('/config?site=' + encodeURIComponent(this.site)));
    if (!r.ok) throw new Error(`config ${r.status}`);
    return r.json();
  }

  async postMessage(args: {
    text?: string;
    attachment_urls?: string[];
    inquiry_id?: string | null;
    client_session?: string;
    member_id?: string;
    member_name?: string;
    member_phone?: string;
  }): Promise<PostMessageResult> {
    const r = await fetch(this.url('/messages'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ site: this.site, ...args }),
    });
    if (!r.ok) throw new Error(`postMessage ${r.status}`);
    return r.json();
  }

  async pollMessages(args: {
    inquiry_id?: string | null;
    client_session?: string;
    since?: string | null;
  }): Promise<PollResult> {
    const qs = new URLSearchParams({ site: this.site });
    if (args.inquiry_id) qs.set('inquiry_id', args.inquiry_id);
    if (args.client_session) qs.set('client_session', args.client_session);
    if (args.since) qs.set('since', args.since);
    const r = await fetch(this.url('/messages?' + qs.toString()));
    if (!r.ok) throw new Error(`pollMessages ${r.status}`);
    return r.json();
  }

  async identify(args: { inquiry_id: string; name?: string; phone?: string }): Promise<void> {
    const r = await fetch(this.url('/identify'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(args),
    });
    if (!r.ok) throw new Error(`identify ${r.status}`);
  }

  async resume(token: string): Promise<PollResult & { inquiry_id: string }> {
    const r = await fetch(this.url('/resume?t=' + encodeURIComponent(token)));
    if (!r.ok) throw new Error(`resume ${r.status}`);
    return r.json();
  }

  async uploadImage(file: File): Promise<{ url: string; size: number }> {
    const fd = new FormData();
    fd.append('file', file);
    const r = await fetch(this.url('/upload-image'), { method: 'POST', body: fd });
    if (!r.ok) throw new Error(`uploadImage ${r.status}`);
    return r.json();
  }
}
